export const selectFinancialCondominium = ({ explicit, remembered, active, preferred, allowedIds }) => {
  const allowed = (id) => Boolean(id) && (allowedIds.size === 0 || allowedIds.has(id));
  return [explicit, remembered, active, preferred, ...allowedIds].find(allowed) || '';
};
